import { createContext } from "react";

interface FormControlContextValue {
  readonly isRequired: boolean | undefined;
  readonly isDirty: boolean | undefined;

  readonly isInvalid: boolean | undefined;
}
export const FormControlContext = createContext<FormControlContextValue>({
  isRequired: undefined,
  isDirty: undefined,
  isInvalid: undefined,
});
